var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaterTapTool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 41.9,
    height: 42.1,
    viewBox: "0 0 41.9 42.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Pfad_371",
    x: 0,
    y: 0.1,
    width: 41.9,
    height: 42,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#00c4ff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#Pfad_371)",
    transform: "translate(3, 3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 0A17.991 17.991 0 0 0 1.512 25.21L3.177 24A15.817 15.817 0 0 1 2 18a16.05 16.05 0 1 1 8.2 13.95L9.054 33.6A17.993 17.993 0 1 0 18 0",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.99 31.12a12.572 12.572 0 0 0 10.2-5.24 2.325 2.325 0 0 0-.43-3.13l-.12-.11a2.287 2.287 0 0 0-1.76-.52 2.483 2.483 0 0 0-1.68.99 7.7 7.7 0 0 1-3.6 2.7.493.493 0 0 0-.3.64.5.5 0 0 0 .64.3 8.823 8.823 0 0 0 4.07-3.04 1.468 1.468 0 0 1 .99-.6 1.343 1.343 0 0 1 1 .3l.12.1a1.333 1.333 0 0 1 .26 1.79 11.59 11.59 0 0 1-9.39 4.82c-2.83 0-5.63-.9-7.13-2.31l-.39-.37-2.43 3.06-1.25 1.58c.26.21.53.41.8.59l1.24-1.57 1.76-2.21a12.256 12.256 0 0 0 7.4 2.23",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.74 16.41v-.04C23.68 13.13 18 5 18 5s-5.7 8.13-5.74 11.37c0 .02-.01.03-.01.04a5.745 5.745 0 1 0 11.49 0m-4.66-.04a1.47 1.47 0 1 1 2.94 0v.02a1.47 1.47 0 1 1-2.94 0z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.05 22.22a9.748 9.748 0 0 0 6.33 3.12 1.007 1.007 0 0 1 .72.34.82.82 0 0 1 .21.64l-.01.12a.87.87 0 0 1-.88.82 8.671 8.671 0 0 1-5.43-2.07.5.5 0 1 0-.65.76 9.66 9.66 0 0 0 6.06 2.31 1.906 1.906 0 0 0 1.89-1.73l.01-.12a1.853 1.853 0 0 0-.44-1.39 2.068 2.068 0 0 0-1.43-.68 8.779 8.779 0 0 1-5.66-2.81 1.943 1.943 0 0 0-2.56-.22l-5.37 4.12-1.62 1.24c.16.29.33.58.52.86l1.6-1.22 5.48-4.2a.935.935 0 0 1 1.23.11",
    fill: "#f5f5f5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterTapTool);
export default __webpack_public_path__ + "static/media/water-tap-tool.5eae9b227543b9408e4ce8badd1384bb.svg";
export { ForwardRef as ReactComponent };